
export default class NavBar {

  constructor(offCanvasWrap, nav, toggleButton, dismissButton) {
    this.offCanvasWrap = offCanvasWrap;
    this.nav = nav;
    this.toggleButton = toggleButton;
    this.dismissButton = dismissButton;
    this.toggled = false;
    this.dropDownToggles = Array.prototype.slice.call(this.nav.getElementsByTagName('UL')[0].children)
      .filter(item => item.getElementsByTagName('UL').length > 0)
      .map(item => item.getElementsByTagName('A')[0]);

    this.updateDOM = this.updateDOM.bind(this);
    this.toggleOffCanvas = this.toggleOffCanvas.bind(this);
    this.dismissOffCanvas = this.dismissOffCanvas.bind(this);
    this.setNavScroll = this.setNavScroll.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  updateDOM() {
    this.offCanvasWrap.setAttribute('data-offcanvas', this.toggled);

    this.toggleButton.setAttribute('aria-label', `${ this.toggled ? 'hide' : 'show' } navigation`);

    this.dismissButton.setAttribute('aria-hidden', !this.toggled);
  }

  toggleOffCanvas() {
    this.toggled = !this.toggled;

    this.updateDOM();
  }

  dismissOffCanvas() {
    this.toggled = false;

    this.updateDOM();
  }

  toggleDropdown(event) {
    const selectedToggle = event.target;
    const openedToggle = this.dropDownToggles.filter(toggle => toggle.getAttribute('aria-expanded') === 'true')[0];
    const selectedDropdown = selectedToggle.parentNode.getElementsByTagName('UL')[0];
    const dropdownHeight = Array.prototype.slice.call(selectedDropdown.children).reduce((previous, current) => previous + current.offsetHeight, 0);

    if (selectedToggle.getAttribute('aria-expanded') === 'false' && window.innerWidth <= 1024) {
      event.preventDefault();

      // Close previously opened dropdown
      if (openedToggle) {
        openedToggle.setAttribute('aria-expanded', false);
        openedToggle.parentNode.getElementsByTagName('UL')[0].style.height = null;
      }

      selectedToggle.setAttribute('aria-expanded', true);
      selectedDropdown.style.height = `${dropdownHeight}px`;
    }
  }

  setNavScroll(isMobile) {
    const transformString = isMobile ? `translate(${this.nav.offsetWidth}px, ${ window.scrollY }px)` : null;

    this.nav.style.webkitTransform = transformString;
    this.nav.style.transform = transformString;
  }

  handleScroll() {
    this.setNavScroll(window.innerWidth < 1024);
  }

  handleResize() {
    const isMobile = window.innerWidth < 1024;
    const openedToggle = this.dropDownToggles.filter(toggle => toggle.getAttribute('aria-expanded') === 'true')[0];

    this.setNavScroll(isMobile);

    if (isMobile && openedToggle) {
      openedToggle.setAttribute('aria-expanded', false);
      openedToggle.parentNode.getElementsByTagName('UL')[0].style.height = null;
    }
  }

  init() {
    this.updateDOM();

    this.toggleButton.addEventListener('click', this.toggleOffCanvas);

    this.dismissButton.addEventListener('click', this.dismissOffCanvas);

    this.dropDownToggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', false);
      toggle.setAttribute('aria-haspopup', true);

      toggle.addEventListener('click', this.toggleDropdown);
    });

    window.addEventListener('scroll', this.handleScroll);

    window.addEventListener('resize', this.handleResize);
  }

};



// WEBPACK FOOTER //
// ./components/nav-bar.js